import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthTokenService } from '../services/authentication/auth-token.service';
import { RoutingStateService } from '../services/routing-state.service';

@Injectable()
export class AuthGuard {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Authenticated ✔
    if (AuthTokenService.getAccessToken()) {
      return true;
    }
    // no Authenticated ✘
    else {
      RoutingStateService.returnUrl =
        window.location.pathname +
        window.location.search.replaceAll('%25', '%').replaceAll('%3A', ':');
      this.router.navigate(['./account/login']);
      return false;
    }
  }
}
